// extracted by mini-css-extract-plugin
export default {"container":"user_container__XR4Kl","animated":"user_animated__6kTo2","head":"user_head__X+kMS","hovered":"user_hovered__LDEE4","nod":"user_nod__p8F9n"};